var options = { hour: '2-digit', minute: '2-digit', second: '2-digit' };//toUTCString
function formatHour(props) {

    return new Date(props.created_at).toLocaleTimeString('en-US', options);

}

export default formatHour;